import api from './api';
import { ApiResponse } from '../types';

export type LateFeeKind = 'flat' | 'percent' | 'daily_flat' | 'daily_percent';

export interface LateFeePolicy {
  schoolId: string;
  enabled: boolean;
  /** Challans generated without a due date fall due this many days after issue. */
  dueDays: number;
  graceDays: number;
  kind: LateFeeKind;
  /**
   * Interpretation depends on `kind`:
   *   flat / daily_flat        — currency amount
   *   percent / daily_percent  — percent, 0..100
   */
  amount: number;
  cap: number | null;
  updatedBy?: string | null;
  updatedAt?: string | null;
}

export const getLateFeePolicy = async (): Promise<LateFeePolicy> => {
  const response = await api.get<ApiResponse<LateFeePolicy>>('/late-fee-policy');
  if (!response.data.success) throw new Error(response.data.message);
  return response.data.data!;
};

export interface LateFeePolicyInput {
  enabled: boolean;
  dueDays: number;
  graceDays: number;
  kind: LateFeeKind;
  amount: number;
  cap: number | null;
}

export const updateLateFeePolicy = async (payload: LateFeePolicyInput): Promise<LateFeePolicy> => {
  const response = await api.put<ApiResponse<LateFeePolicy>>('/late-fee-policy', payload);
  if (!response.data.success) throw new Error(response.data.message);
  return response.data.data!;
};

const lateFeePolicyService = {
  getLateFeePolicy,
  updateLateFeePolicy,
};

export default lateFeePolicyService;
